/**
 * Determines if a user has admin privileges based on their rank.
 * @param {Object} user - The user object containing a rank property.
 * @returns {boolean} - True if the user is an admin, false otherwise.
 */
export function isAdmin(user) {
    if (!user || typeof user !== 'object') {
        return false
    }
    if (!user.rank || typeof user.rank !== 'string') {
        return false
    }
    const rank = user.rank.trim().toLowerCase()
    return rank.includes('admin')
}